import { FigmaImage, PanesContainer, useNotionDatabase } from "dev";

import { SubstatusIcon } from "@/src/components/substatus-icon";
import { PaymentMethod, Status, Substatus } from "@/src/types";

const manual_non_card_methods: Array<{
  substatus: Substatus<Status>;
  paymentMethod: PaymentMethod;
  figma_url: string;
  expected_icon: string;
  expected_icon_color: string;
}> = [
  {
    substatus: "manual_payment_pending",
    paymentMethod: "yappy",
    figma_url:
      "https://www.figma.com/file/n6LDDhVWY86pE5GGcptGyp/Integrate-Carriers?type=design&node-id=272-5707&mode=design&t=pt5F9zEyMOLCOlMq-4",
    expected_icon: "yappy",
    expected_icon_color: "red",
  },
  {
    substatus: "manual_payment_pending",
    paymentMethod: "sinpe_movil",
    figma_url:
      "https://www.figma.com/file/n6LDDhVWY86pE5GGcptGyp/Integrate-Carriers?type=design&node-id=290-5354&mode=design&t=pt5F9zEyMOLCOlMq-4",
    expected_icon: "sinpe_movil",
    expected_icon_color: "red",
  },
  {
    substatus: "manual_payment_pending",
    paymentMethod: "ach",
    figma_url:
      "https://www.figma.com/file/n6LDDhVWY86pE5GGcptGyp/Integrate-Carriers?type=design&node-id=290-5123&mode=design&t=pt5F9zEyMOLCOlMq-4",
    expected_icon: "ach",
    expected_icon_color: "red",
  },
  {
    substatus: "manual_payment_pending",
    paymentMethod: "sinpe",
    figma_url:
      "https://www.figma.com/file/n6LDDhVWY86pE5GGcptGyp/Integrate-Carriers?type=design&node-id=290-5241&mode=design&t=pt5F9zEyMOLCOlMq-4",
    expected_icon: "sinpe",
    expected_icon_color: "red",
  },
  {
    substatus: "manual_payment_pending",
    paymentMethod: "cash",
    figma_url:
      "https://www.figma.com/file/n6LDDhVWY86pE5GGcptGyp/Integrate-Carriers?type=design&node-id=290-5470&mode=design&t=pt5F9zEyMOLCOlMq-4",
    expected_icon: "cash",
    expected_icon_color: "red",
  },
];

export default function StatusIcons() {
  const db = useNotionDatabase("8c4fe0fab8f34935930d914dbff0ae7a");

  if (!db) return null;

  const data = db
    .map((r) => {
      const substatus = r["Sub-status"] as Substatus<Status>;
      const paymentMethod = "card" as PaymentMethod;
      const figma_url = r["Consumer Figma Link"];
      const expected_icon = r["Icon"];
      const expected_icon_color = r["Icon Color"];

      return {
        substatus,
        paymentMethod,
        figma_url,
        expected_icon,
        expected_icon_color,
      };
    })
    .concat(manual_non_card_methods);

  return (
    <PanesContainer
      items={data}
      numColumns={4}
      renderItem={(
        {
          substatus,
          paymentMethod,
          figma_url,
          expected_icon,
          expected_icon_color,
        },
        index
      ) => (
        <>
          <>
            <span>data passed to component</span>
            <span>substatus: {substatus}</span>
            <span>paymentMethod: {paymentMethod}</span>
          </>

          <>
            <span>data in notion db</span>
            <span>expected_icon: {expected_icon}</span>
            <span>expected_icon_color: {expected_icon_color}</span>
          </>

          <SubstatusIcon substatus={substatus} paymentMethod={paymentMethod} />

          <FigmaImage url={figma_url} fetchDelayMs={index * 500} />
        </>
      )}
    />
  );
}
